import { CustomFormLabel } from 'components';
import CommunicationEmailAdd from 'containers/communication/CommunicationEmailAdd';
import EditableEmailAddress from 'containers/communication/EditableEmailAddress';
import React, { useCallback, useEffect, useState } from 'react';
import { texts } from 'utils/languages/fr';

const MAX_ADDRESSES = 20;

const SubscriptionEmaillList = ({ defaultValue = [], onChange }) => {
    const [addresses, setAddresses] = useState(defaultValue);
    const handleAddAddress = useCallback(newAddress => {
        setAddresses(prevState => [...prevState, newAddress]);
    }, []);
    const handleDeleteAddress = useCallback(
        index => () => {
            setAddresses(prevState => prevState.filter((_, i) => i !== index));
        },
        []
    );
    const handleUpdateAddress = useCallback(
        index => newValue => {
            setAddresses(prevState => prevState.map((add, i) => (i === index ? newValue : add)));
        },
        []
    );

    useEffect(() => {
        onChange(addresses);
    }, [onChange, addresses]);

    return (
        <React.Fragment>
            <CustomFormLabel>{texts.COMPLEMENTARY_ADDRESSES}</CustomFormLabel>
            {addresses.length < MAX_ADDRESSES && (
                <CommunicationEmailAdd
                    avoidCallbacks
                    onAdd={handleAddAddress}
                    addresses={addresses}
                />
            )}
            {addresses.map((address, i) => (
                <EditableEmailAddress
                    key={i}
                    avoidCallbacks
                    defaultValue={address}
                    onUpdate={handleUpdateAddress(i)}
                    onDelete={handleDeleteAddress(i)}
                />
            ))}
        </React.Fragment>
    );
};

export default SubscriptionEmaillList;
